module.exports = __webpack_public_path__ + "static/media/MouseClicker.902da162.png";